import { PayoutMethod } from '~/swagger/portal/Api';
import type { BillPayment } from '~/types/payVendorBills';

/** 切换 Set 中某元素的包含状态 */
export function toggleSetMember<T>(set: Set<T>, member: T): Set<T> {
  const next = new Set(set);
  if (next.has(member)) next.delete(member);
  else next.add(member);
  return next;
}

/** 按 key 分组数组 */
export function groupBy<K, V>(items: V[], getKey: (item: V) => K): Map<K, V[]> {
  const map = new Map<K, V[]>();
  for (const item of items) {
    const key = getKey(item);
    const existing = map.get(key) ?? [];
    map.set(key, [...existing, item]);
  }
  return map;
}

/** 解析拖拽事件中的 payload */
export function parseDragPayload(event: DragEvent): { vendorId: string; billId: string; sourceSectionId: string } | null {
  try {
    const data = event.dataTransfer?.getData('text');
    if (!data) return null;
    const parsed = JSON.parse(data) as { vendorId?: string; billId?: string; sourceSectionId?: string };
    const { vendorId, billId, sourceSectionId } = parsed;
    if (!vendorId || !billId || !sourceSectionId) return null;
    return { vendorId, billId, sourceSectionId };
  } catch {
    return null;
  }
}

/** 校验 bill payment 是否可提交 */
export function isBillPaymentValid(bill: BillPayment): boolean {
  if (bill.excluded) return false;
  if (!bill.paymentAmount || bill.paymentAmount <= 0 || !bill.paymentBankAccountId) return false;
  if (bill.paymentType === PayoutMethod.Ach && !bill.receivingBankAccountId) return false;
  if (bill.paymentType === PayoutMethod.Manual && !bill.externalTransactionId) return false;
  return true;
}
